import { render, staticRenderFns } from "./drawerProjectsTaskFlowSuspend.vue?vue&type=template&id=a61eaa72&"
import script from "./drawerProjectsTaskFlowSuspend.vue?vue&type=script&lang=js&"
export * from "./drawerProjectsTaskFlowSuspend.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports